module.exports = __webpack_public_path__ + "static/media/bitcoin-logo.775b91f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/ways-to-pay/bitcoin-logo.png
// module id = 2235
// module chunks = 0